import { api } from './api';

export const investmentsApi = {
  // Investments CRUD
  list: (accountId) =>
    api.get('/investments', { params: accountId ? { account_id: accountId } : {} }).then((r) => r.data),
  get: (id) => api.get(`/investments/${id}`).then((r) => r.data),
  create: (data) => api.post('/investments', data).then((r) => r.data),
  update: (id, data) => api.patch(`/investments/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/investments/${id}`).then((r) => r.data),

  // Portfolio (dashboard data)
  portfolio: () => api.get('/investments/portfolio').then((r) => r.data),

  // Value history (per-account capital deployed over time + today's valuation)
  valueHistory: () => api.get('/investments/value-history').then((r) => r.data),

  // Prices
  prices: () => api.get('/investments/prices').then((r) => r.data),
  setPrice: (data) => api.post('/investments/prices', data).then((r) => r.data),
  refreshPrices: () => api.post('/investments/prices/refresh').then((r) => r.data),
  priceHistory: (days = 30) =>
    api.get('/investments/prices/history', { params: { days } }).then((r) => r.data),

  // Investment transactions
  transactions: (investmentId) =>
    api.get(`/investments/${investmentId}/transactions`).then((r) => r.data),
  addTransaction: (investmentId, data) =>
    api.post(`/investments/${investmentId}/transactions`, data).then((r) => r.data),
  updateTransaction: (investmentId, rowId, data) =>
    api.patch(`/investments/${investmentId}/transactions/${rowId}`, data).then((r) => r.data),
  removeTransaction: (investmentId, rowId) =>
    api.delete(`/investments/${investmentId}/transactions/${rowId}`).then((r) => r.data),

  // APY history
  apy: (investmentId) => api.get(`/investments/${investmentId}/apy`).then((r) => r.data),
  addApy: (investmentId, data) =>
    api.post(`/investments/${investmentId}/apy`, data).then((r) => r.data),

  // Savings (term account) APY history
  savingsApy: (accountId) => api.get(`/accounts/${accountId}/apy`).then((r) => r.data),
  addSavingsApy: (accountId, data) =>
    api.post(`/accounts/${accountId}/apy`, data).then((r) => r.data),
  removeSavingsApy: (entryId) =>
    api.delete(`/accounts/apy/${entryId}`).then((r) => r.data),
};